import { getLanguageCode } from '../../../../utils/getURLParams';
import { getEnv } from '../../../../utils/getEnv';

class GoogleDataLayer {

  createProductProperty(name, product_id, price, quantity, variant, ticket_id, flex_option, brand, category, sku){
    return {
      name: name,
      id: product_id,
      price: price,
      quantity: quantity,
      variant: variant ? variant : '',
      ticket_id: ticket_id,
      flex_option: flex_option ? flex_option : '',
      brand: '',
      category: category ? category : '',
      sku: sku ? sku : '',
    }
  }

  logCheckoutEvent(dataLayer) {
    window.dataLayer.push(dataLayer)
  }

  createCheckoutEvent(productProperty){
    const checkoutEventDataLayer = {
      event: 'checkout',
      ecommerce: {
        checkout:{
          actionField: {
            step: 1,
            option: "Checkout",
          },
          products: productProperty
        }
      }
    }
    this.logCheckoutEvent(checkoutEventDataLayer)
  }

  createOrderCreationEvent(loginOrderId, orderStatus, userId, paymentMethod) {
    const orderCreationEventDataLayer = {
      event: "order_status",
      order_status: {
        loginOrderId: loginOrderId,
        orderStatus: orderStatus,
        userId: userId,
        paymentMethod: paymentMethod,
      }
    }
    this.logCheckoutEvent(orderCreationEventDataLayer);
  }

  createPageEvent() {

  const domainPrefix = getLanguageCode('Atd');
  const env = getEnv()

  window.dataLayer = window.dataLayer || [];

    const page = {
      page: {
        domain: domainPrefix,
        ...env !== 'live' ? { environment:'staging'} : {environment:'production'},
        event:"dataLayerFires",
        node_nid:"",
        node_title:"checkout",
        node_type:"checkout",
        order_number:"",
        user_email:"",
        user_type:"",}
    }

    // Adding page event at index 0 as requested.
    window.dataLayer.splice(0,0,page)
  }

  createUserClickInputEvent(fieldName){
    const userClickInputEvent = {
      event: fieldName,
    }
    this.logCheckoutEvent(userClickInputEvent);
  }

  createDiscountFormEvent(discountCode,discountCodeValue){
    const discountField = {
      event: 'discountCodeApply',
      discountCode: {
        discount_code: discountCode,
        discount_value: discountCodeValue,
      }
    }
    this.logCheckoutEvent(discountField);
  }

  createPaymentMethodChoiceEvent(activePaymentAction){
    const paymentMethod = {
      event: 'paymentMethodSelect',
      paymentMethod: activePaymentAction,
    }
    this.logCheckoutEvent(paymentMethod);
  }

  createPaymentOptionChoiceEvent(paymentOptionSelected,paymentValue){
    const paymentOption = {
      event: "paymentOptionSelect",
      paymentOption: {
          payment_option: paymentOptionSelected,
          payment_value: paymentValue,
        }
    }
    this.logCheckoutEvent(paymentOption);
  }

  createCheckboxClickEvent(eventName, checked){
    const boxEvent = {
      event: eventName,
      agreed: checked,
    }
    this.logCheckoutEvent(boxEvent);
  }

  createDepartureDateEvent(date){
    const departureDate = {
      event: 'departure_date',
      date: date,
    }
    this.logCheckoutEvent(departureDate);
  }

  createTicketDetailsFieldsEvent(fieldTitle,ticketTitle,fieldName){
    const ticketDetails = {
      event: fieldTitle,
      field_for: fieldName,
      product: ticketTitle
    }
    this.logCheckoutEvent(ticketDetails);
  }

  createAutocompleteEvent(fieldName,attTitle,product,fieldTitle){

    let field;

    if (fieldTitle !== undefined) {
      field = {
        event: attTitle + '_autocomplete',
        field_for: fieldTitle,
        product: product
      }
    } else {
      field = {
        event: fieldName + '_autocomplete',
      }
    }

    this.logCheckoutEvent(field);

  }

}

export const googleDataLayer = new GoogleDataLayer()
